module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-layout', {
    staticClass: "px-2 pt-3",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('div', {
    staticClass: "layout row wrap"
  }, [_c('v-select', {
    staticClass: "min-w mx-3",
    attrs: {
      "items": _vm.months,
      "label": _vm.$lang.actions.selectMonth,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingMonth)); }]
    },
    model: {
      value: (_vm.time.month),
      callback: function($$v) {
        _vm.$set(_vm.time, "month", $$v)
      },
      expression: "time.month"
    }
  }), _vm._v(" "), _c('v-select', {
    staticClass: "min-w mx-3",
    attrs: {
      "items": _vm.years,
      "label": _vm.$lang.actions.selectYear,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingYear)); }]
    },
    model: {
      value: (_vm.time.year),
      callback: function($$v) {
        _vm.$set(_vm.time, "year", $$v)
      },
      expression: "time.year"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mx-2 my-2",
    attrs: {
      "disabled": !_vm.valid
    },
    on: {
      "click": function($event) {
        return _vm.showReports()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.showReports))]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mx-2 my-2",
    attrs: {
      "disabled": _vm.reports.length === 0
    },
    on: {
      "click": function($event) {
        return _vm.showOverview()
      }
    }
  }, [_vm._v(_vm._s(!_vm.showOverviewData ? _vm.$lang.actions.showPaymentOverview : _vm.$lang.actions.hidePaymentOverview))])], 1)]), _vm._v(" "), (_vm.show) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3",
    attrs: {
      "append-icon": "search",
      "label": _vm.$lang.labels.search
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": "",
      "pb-3": ""
    }
  }, [_c('v-alert', {
    staticClass: "my-0",
    attrs: {
      "type": "error",
      "value": true
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.show) ? _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.reports,
      "search": _vm.search,
      "loading": _vm.loading,
      "rows-per-page-items": [50, 100, 250, 500, {
        text: 'All',
        value: -1
      }]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.type))]), _vm._v(" "), _c('td', {
          staticClass: "min-w"
        }, [_vm._v(_vm._s(props.item.companyName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(props.item.createdOn)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.months[parseInt(props.item.month, 10) - 1].text))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.year))]), _vm._v(" "), (_vm.showOverviewData) ? _c('td', [_c('v-layout', {
          attrs: {
            "row": "",
            "wrap": ""
          }
        }, [_c('v-flex', {
          attrs: {
            "xs6": ""
          }
        }, [_c('span', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm.$lang.labels.webshopOrderNo) + ": " + _vm._s((_vm.calculateOrderData(props.item.webShopResources, 'webshop')).noOfOrders))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm.$lang.labels.appOrderNo) + ": " + _vm._s((_vm.calculateOrderData(props.item.webShopResources, 'ordering app')).noOfOrders))])]), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs6": ""
          }
        }, [_vm._l((_vm.calculatePaymentSummary(props.item.webShopResources.map(function (x) { return x.paymentSummary; }).flat(Infinity))), function(type) {
          return [_c('span', {
            staticClass: "text-xs-left"
          }, [_vm._v(_vm._s(_vm.$lang.labels[type.paymentType]) + ": " + _vm._s(type.amount))]), _c('br')]
        }), _vm._v(" "), _c('span', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm.$lang.labels.webshopTotal) + ": " + _vm._s((_vm.calculateOrderData(props.item.webShopResources, 'webshop')).ordersSum))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm.$lang.labels.appTotal) + ": " + _vm._s((_vm.calculateOrderData(props.item.webShopResources, 'ordering app')).ordersSum))])], 2)], 1)], 1) : _vm._e(), _vm._v(" "), _c('td', [_c('v-btn', {
          staticClass: "primary mx-0",
          on: {
            "click": function($event) {
              return _vm.showReportDetails(props.item)
            }
          }
        }, [_vm._v(_vm._s(_vm.$lang.actions.view))])], 1)]
      }
    }], null, false, 1509858075)
  }, [_c('v-progress-linear', {
    attrs: {
      "slot": "progress",
      "height": "6",
      "color": "primary",
      "indeterminate": ""
    },
    slot: "progress"
  }), _vm._v(" "), _vm._v(" "), _c('v-alert', {
    attrs: {
      "slot": "no-results",
      "value": true,
      "color": "warning",
      "icon": "warning"
    },
    slot: "no-results"
  }, [_vm._v("\n        Your search for \"" + _vm._s(_vm.search) + "\" found no results.\n      ")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.reportDetailsModal) ? _c('v-dialog', {
    attrs: {
      "max-width": "1200"
    },
    model: {
      value: (_vm.reportDetailsModal),
      callback: function($$v) {
        _vm.reportDetailsModal = $$v
      },
      expression: "reportDetailsModal"
    }
  }, [_c('report-details-modal', {
    attrs: {
      "reportDetails": _vm.reportDetails
    },
    on: {
      "close": function($event) {
        _vm.reportDetailsModal = false
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ee711e0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/webshopReports/WebshopReports.vue
// module id = 385
// module chunks = 35